import { API_V1_PREFIX } from '../shared/api.constants';

export const CONFIGURATION_ENDPOINT = `${API_V1_PREFIX}/configuration`;
export const LOG_ENDPOINT = `${API_V1_PREFIX}/log`;
export const USER_INFO_ENDPOINT = `${API_V1_PREFIX}/getUserInfo`;
export const AUTHORIZATION_ENDPOINT = `${API_V1_PREFIX}/authorization`;
